import { Theme, alpha } from '@mui/material/styles';

export type StatCardColor =
  | 'violet'
  | 'slateBlue'
  | 'cyan'
  | 'teal'
  | 'orange'
  | 'rose'
  | 'gray'
  | 'green';

export type StatCardTokens = {
  background: string;
  border: string;
  iconBackground: string;
  iconColor: string;
  textColor: string;
  hoverBackground: string;
  hoverShadow: string;
};

export const getStatCardTokens = (
  theme: Theme,
  color: StatCardColor
): StatCardTokens => {
  const paletteScale = theme.palette[color];
  const isDarkMode = theme.palette.mode === 'dark';

  if (isDarkMode) {
    return {
      background: paletteScale[600],
      border: paletteScale[700],
      iconBackground: alpha(theme.palette.common.black, 0.2),
      iconColor: paletteScale[300],
      textColor: theme.palette.common.white,
      hoverBackground: paletteScale[500],
      hoverShadow: 'none',
    };
  }

  return {
    background: paletteScale[100],
    border: paletteScale[200],
    iconBackground: alpha(theme.palette.common.white, 0.5),
    iconColor: paletteScale[400],
    textColor: theme.palette.text.primary,
    hoverBackground: paletteScale[100],
    hoverShadow: theme.shadows[2],
  };
};
